import classNames from 'classnames';

type Props = React.ComponentProps<'div'>;

const Card: React.FC<Props> = ({ className, ...rest }) => (
  <div className={classNames('p-5 shadow-md', className)} {...rest} />
);

export default Card;
